/**
 * Sticky column headers for a table that can outgrow the viewport (TMMPDM-0035, TBL-017): the
 * `TableContainer` scrolls inside the room the page header leaves (`custom.layout`), and the
 * `Table` takes `stickyHeader`, so the header row stays in view and never meets the page header.
 */
import type { SxProps, Theme } from '@mui/material/styles';

export const stickyTableContainerSx: SxProps<Theme> = {
  maxHeight: (theme) => `calc(100vh - ${theme.custom.layout.stickyTableOffset}px)`,
};
